import { render, staticRenderFns } from "./FabSpacer.component.vue?vue&type=template&id=606eb970&scoped=true&"
import script from "./FabSpacer.component.vue?vue&type=script&lang=js&"
export * from "./FabSpacer.component.vue?vue&type=script&lang=js&"
import style0 from "./FabSpacer.component.vue?vue&type=style&index=0&id=606eb970&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606eb970",
  null
  
)

export default component.exports